import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['action', 'character', 'characterStep', 'avatarStep', 'avatarGroup', 'avatar', 'soundStep', 'sound', 'apply', 'error'];

  connect() {
    this.refresh();
    this.dispatch('ready');
  }

  get selectedAction() { return this.actionTargets.find(input => input.checked); }

  get selectedAvatar() {
    return this.avatarTargets.find(input => input.checked && !input.disabled && input.dataset.characterId === this.characterTarget.value);
  }

  get complete() {
    return Boolean(this.selectedId);
  }

  get selectedId() {
    if (this.selectedAction?.value === 'character_avatar.show_on_character') return this.selectedAvatar?.value;
    if (this.selectedAction?.value === 'sound_effect.play_once') return this.soundTarget.value;
  }

  refresh() {
    const usesAvatar = this.selectedAction?.value === 'character_avatar.show_on_character';
    this.soundStepTarget.hidden = this.selectedAction?.value !== 'sound_effect.play_once';
    this.soundTarget.disabled = this.soundStepTarget.hidden;
    this.characterStepTarget.hidden = !usesAvatar;
    this.avatarStepTarget.hidden = !usesAvatar || !this.characterTarget.value;
    for (const group of this.avatarGroupTargets) group.hidden = group.dataset.characterId !== this.characterTarget.value;
    for (const avatar of this.avatarTargets) {
      avatar.disabled = !usesAvatar || avatar.dataset.characterId !== this.characterTarget.value;
      if (avatar.disabled) avatar.checked = false;
    }
    this.applyTarget.disabled = !this.complete;
    this.errorTarget.textContent = '';
  }

  populate(event) {
    const effect = event.detail.effect;
    if (!effect?.automatable_id) return;
    const action = this.actionTargets.find(input => input.value === effect.automatable_effect);
    for (const input of this.actionTargets) input.checked = input === action;
    const avatar = effect.automatable_effect === 'character_avatar.show_on_character' &&
      this.avatarTargets.find(input => input.value === String(effect.automatable_id));
    this.characterTarget.value = avatar ? avatar.dataset.characterId : '';
    for (const input of this.avatarTargets) input.checked = input === avatar;
    this.soundTarget.value = effect.automatable_effect === 'sound_effect.play_once' ? String(effect.automatable_id) : '';
    this.characterTarget.dispatchEvent(new Event('change', { bubbles: true }));
    this.refresh();
    if (!action || !this.complete) this.errorTarget.textContent = 'This effect is no longer available. Choose another effect to replace it.';
  }

  save(event) {
    const action = this.selectedAction;
    if (!this.complete) {
      event.stopImmediatePropagation();
      this.errorTarget.textContent = 'Choose an effect, character and avatar, or a sound effect.';
      return;
    }
    this.dispatch('save', { detail: { effect: {
      automatable_id: Number(this.selectedId), automatable_effect: action.value } } });
  }
}
